export default function EmployeeTable({ entries = [] }) {
   const totals = entries.reduce(
    (acc, e) => {
      const r = e.raw_json || {};

      acc.gross_pay += r.gross_pay || 0;
      acc.taxable_gross += r.taxable_gross || 0;
      acc.nic_able_gross += r.nic_able_gross || 0;
      acc.tax += r.tax || 0;
      acc.employee_nics += r.employee_nics || 0;
      acc.student_loans +=
        (r.student_loan_deductions || 0) +
        (r.postgrad_loan_deductions || 0);
      acc.net_pay += r.net_pay || 0;
      acc.take_home_pay += r.take_home_pay || 0;
      acc.employer_nics += r.employer_nics || 0;
      acc.employer_pension += r.employer_pension || 0;
      acc.cost_to_employer += r.cost_to_employer || 0;

      return acc;
    },
    {
      gross_pay: 0,
      taxable_gross: 0,
      nic_able_gross: 0,
      tax: 0,
      employee_nics: 0,
      student_loans: 0,
      net_pay: 0,
      take_home_pay: 0,
      employer_nics: 0,
      employer_pension: 0,
      cost_to_employer: 0,
    }
  );
  return (
    <div className="w-full overflow-x-auto">
      <table
        className="min-w-max table table-bordered bg-white mb-0 text-sm"
        style={{ minWidth: "1600px" }}
      >
        <thead className="bg-gray-200 sticky top-0">
          <tr>
            <Th>First Name</Th>
            <Th>Surname</Th>
            <Th r>Gross Pay</Th>
            <Th r>Taxable Gross</Th>
            <Th r>NIC-able Gross</Th>
            <Th r>Tax</Th>
            <Th r>Employee NICs</Th>
            <Th r>Student + Postgrad Loan</Th>
            <Th r>Net Pay</Th>
            <Th r>Take-home Pay</Th>
            <Th r>Employer NICs</Th>
            <Th r>Employer Pension</Th>
            <Th r>Cost to Employer</Th>
          </tr>
        </thead>

        <tbody>
          {entries.map((e, i) => {
            const r = e.raw_json || {};

            return (
              <tr key={i} className="hover:bg-gray-50">
                <Td>{r.employee_first_name || "-"}</Td>
                <Td>{r.employee_surname || "-"}</Td>

                <Td r>{money(r.gross_pay)}</Td>
                <Td r>{money(r.taxable_gross)}</Td>
                <Td r>{money(r.nic_able_gross)}</Td>

                <Td r className="text-danger">{money(r.tax)}</Td>
                <Td r className="text-warning">{money(r.employee_nics)}</Td>
                <Td r className="text-info">
                  {money(
                    r.student_loan_deductions ??
                    r.postgrad_loan_deductions
                  )}
                </Td>

                <Td r className="text-primary">{money(r.net_pay)}</Td>
                <Td r className="text-success fw-semibold">
                  {money(r.take_home_pay)}
                </Td>

                <Td r>{money(r.employer_nics)}</Td>
                <Td r>{money(r.employer_pension)}</Td>
                <Td r className="fw-semibold text-info">
                  {money(r.cost_to_employer)}
                </Td>
              </tr>
            );
          })}
        </tbody>
        {entries.length > 0 && (
          <tfoot className="bg-gray-100 fw-semibold">
            <tr>
              <Td></Td>
              <Td r={false} colSpan={2} className="text-end">
                TOTAL
              </Td>

              <Td r>{money(totals.gross_pay)}</Td>
              <Td r>{money(totals.taxable_gross)}</Td>
              <Td r>{money(totals.nic_able_gross)}</Td>

              <Td r className="text-danger">
                {money(totals.tax)}
              </Td>
              <Td r className="text-warning">
                {money(totals.employee_nics)}
              </Td>
              <Td r className="text-info">
                {money(totals.student_loans)}
              </Td>

              <Td r className="text-primary">
                {money(totals.net_pay)}
              </Td>
              <Td r className="text-success fw-bold">
                {money(totals.take_home_pay)}
              </Td>

              <Td r>{money(totals.employer_nics)}</Td>
              <Td r>{money(totals.employer_pension)}</Td>
              <Td r className="fw-bold text-info">
                {money(totals.cost_to_employer)}
              </Td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}

/* =================== HELPERS =================== */

const Th = ({ children, r }) => (
  <th
    className={`px-3 py-2 ${
      r ? "text-end" : "text-start"
    } whitespace-nowrap`}
  >
    {children}
  </th>
);

const Td = ({ children, r, className = "" }) => (
  <td
    className={`px-3 py-2 ${
      r ? "text-end" : "text-start"
    } ${className}`}
  >
    {children}
  </td>
);

const money = (v) =>
  v == null
    ? "–"
    : new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
      }).format(v);
